import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import { withPrefix } from 'gatsby';
import { FootNoteLink } from '@massds/mayflower-react';
import { isInternalLink } from '../../utils/nav';

class DangerousWrapper extends React.Component {
  componentDidMount() {
    const { onMountCallback } = this.props;
    if (typeof onMountCallback === 'function') {
      onMountCallback(this.element);
    }
  }

  getFootnoteIndex = ({ className, vetoLegend }) => {
    const legend = vetoLegend.legend.find((item) => item.outerWrapper === className);
    return legend.index;
  }

  render() {
    const {
      className, id, htmlTag, rawHtml, vetoLegend, ...rest
    } = this.props;
    const CustomElement = htmlTag;
    /**
     * Recursive function that checks for relative links in raw html, and appends the site prefix if found.
     * @param {object} node - The htmlparser2 node to convert to a react.element.
     * @param {number} index - The index of the current node.
     * @returns {react.element} - A react.element. As this is a recursive function, if there are
         nested html children, it will call/pass these children to the funtion.
    */
    const convertLinks = (node, index) => {
      if (node.type === 'tag' && node.name === 'a' && isInternalLink(node.attribs.href)) {
        return(<a href={withPrefix(node.attribs.href)} key={`danger_a_${index}`}>{node.children[0].data}</a>);
      }
      if (node.type === 'tag' && node.name === 'span' && (/ma__gov-veto-outer/.test(node.attribs.class)) && vetoLegend && vetoLegend.legend) {
        return(
          <React.Fragment key={`danger_veto_${index}`}>
            <span className={node.attribs.class}>
              {convertNodeToElement(node.children[0], index, convertLinks)}
            </span>
            <FootNoteLink index={this.getFootnoteIndex({ className: node.attribs.class, vetoLegend })} />
          </React.Fragment>
        );
      }
      return convertNodeToElement(node, index, convertLinks);
    };
    return(
      <CustomElement ref={(element) => { this.element = element; }} className={className} id={id} {...rest}>
        {ReactHtmlParser(rawHtml, { transform: convertLinks })}
      </CustomElement>
    );
  }
}

DangerousWrapper.propTypes = {
  /** The raw html that you want to render. * */
  rawHtml: PropTypes.string,
  /** A className that you want to component to reference. * */
  className: PropTypes.string,
  /** An id to be rendered on the component. * */
  id: PropTypes.string,
  /** The html tag you want the component to be. By default, this is a `div`. * */
  htmlTag: PropTypes.string,
  /** Callback that passes the ref element on component did mount */
  onMountCallback: PropTypes.func,
  /** Veto legend object for adding footnote links */
  vetoLegend: PropTypes.shape({
    legend: PropTypes.arrayOf(PropTypes.shape({
      index: PropTypes.string,
      innerWrapper: PropTypes.oneOf(['ma__gov-veto-inner__strike', 'ma__gov-veto-inner__add', 'ma__gov-veto-inner__strike--overridden', 'ma__gov-veto-inner__add--overridden']),
      outerWrapper: PropTypes.oneOf(['ma__gov-veto-outer__strike', 'ma__gov-veto-outer__add', 'ma__gov-veto-outer__strike--overridden', 'ma__gov-veto-outer__add--overridden'])
    }))
  })
};

DangerousWrapper.defaultProps = {
  htmlTag: 'div'
};

export default DangerousWrapper;
